<template>
    <div class="main-list">
        <bs-table :routeWatch="true" :props="{height:this.$store.getters.tableHeight,view:this.$route.query._view||'table'}" class-name="console"
                  :route="route"></bs-table>
    </div>
</template>
<script>

import { requestCurFindParam} from "../../utils/request";
let _css=requestCurFindParam("_css");
//调用外部样式
if(_css==='true'){
    require("../../styles/main-table-basis.scss");
}
export default {
  data() {
    return {
      route: { params: this.$route.params, query: this.$route.query }
    };
  },
  props: {},
  components: {
    BsTable: () => import("../../components/bs-table")
  },
  created() {},
  beforeMount() {},
  mounted() {},
  methods: {},
  watch: {
    $route: function(to, from) {
      this.route = { params: to.params, query: to.query };
    }
  }
};
</script>
